export default {
  install: function(Vue) {
    /**
     * 定位到该组件
     */
    Object.defineProperty(Vue.prototype, "$pitchComponentPosition", {
      value: function pitchComponentPosition(id) {
        const element = document.getElementById(id);
        element &&
          element.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    });

    // 数字换中文
    Object.defineProperty(Vue.prototype, "$convertToChineseNumber", {
      value: function convertToChineseNumber(number) {
        const chineseNumbers = [
          "一",
          "二",
          "三",
          "四",
          "五",
          "六",
          "七",
          "八",
          "九",
          "十",
          "十一",
          "十二",
          "十三",
          "十四",
          "十五",
          "十六",
          "十七",
          "十八",
          "十九",
          "二十"
        ];
        return chineseNumbers[number - 1];
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/utils/methods.js